import { constant } from "../../../../../config/constant";
import i18n from "../../../../../i18n";
import { getCheckinMarket } from "../../../../../utils/helper";
export const normalize = str => {
  return str?.replace(/([a-z])([A-Z])/g, `$1 $2`).toLowerCase().replace(/\s+/g, "");
};
export const getFlightStatusText = status => {
  let removeSpaces = normalize(status);
  switch (removeSpaces) {
    case "delayed":
      return i18n.t("delayed");
    case "notoperated":
      return i18n.t("label_not_operated");
    case "scheduled":
      return i18n.t("label_checkin_scheduled");
    case "ontime":
      return i18n.t("label_on_time");
    case "cancelled":
      return i18n.t("label_status_cancelled");
    default:
      return status;
  }
};
export const baggageKeyMap = (unit, weight) => {
  switch (unit) {
    case "TA":
      return i18n.t("label_ticket_allowance");
    case "PCS":
      return weight > 1 ? i18n.t("label_pieces") : i18n.t("label_piece");
    case "kilogram":
      return i18n.t("label_kg");
    case "EBA":
      return i18n.t("label_extra_baggage_allowance");
    case "MA":
      return i18n.t("label_member_allowance");
    case "STD":
      return i18n.t("label_checkin_standard");
    default:
      return "NA";
  }
};
export const tierLevelMap = tierLevel => {
  switch (tierLevel) {
    case "Platinum":
      return `${i18n.t("label_platinum_tier")}${" "}`;
    case "Gold":
      return `${i18n.t("label_gold_tier")}${" "}`;
    case "Silver":
      return `${i18n.t("label_silver_tier")}${" "}`;
    case "Member":
      return `${i18n.t("label_basic")}${" "}`;
    default:
      return "";
  }
};
export const getUserType = data => {
  switch (data) {
    case "type":
      if (localStorage?.getItem("isROPLoggedIn") === "true") {
        return "royal_orchid_plus member";
      } else if (localStorage?.getItem("isCRMLoggedIn") === "true") {
        return "register_customer";
      } else {
        return "guest_user";
      }
      break;
    case "status":
      if (localStorage?.getItem("isROPLoggedIn") === "true" || localStorage?.getItem("isCRMLoggedIn") === "true") {
        return "loggedin_user";
      } else {
        return "guest_user";
      }
      break;
  }
};
export const getDeviceType = () => {
  const ua = navigator.userAgent.toLowerCase();
  if (typeof navigator === "undefined" || typeof window === "undefined") {
    return "Web";
  }
  if (/android/i.test(ua) && !/mobile\s?safari/i.test(ua)) {
    return "Android";
  }
  if (/iphone|ipad|ipod/i.test(ua) && !/safari/i.test(ua)) {
    return "IOS";
  }
  const isMobile = /iphone|ipad|ipod|android|mobile/i.test(ua) || window.innerWidth <= 768;
  if (isMobile) {
    return "Mweb";
  }
  return "Web";
};
export const getMarkets = type => {
  switch (type) {
    case "language":
      return window.location.pathname.split("/")[1].split("-")[0];
    case "country":
      return window.location.pathname.split("/")[1].split("-")[1];
    case "market":
      return window.location.pathname.split("/")[1];
    default:
      return "NA";
  }
};
export const getFlightIds = data => {
  let flightsArray = data?.map(item => item.flightId);
  return flightsArray?.join("|");
};
export const getSeatNumbers = (data, page) => {
  let seats;
  if (page !== "completeCheckin") {
    seats = data?.flightsArray?.flatMap?.(item => item?.passengersArray?.map(data => data?.seat?.seatNumber));
  } else {
    seats = data?.flightsArray?.flatMap?.(item => item?.checkedinPassengers?.map(data => data?.seat?.seatNumber));
  }
  return seats?.join("|");
};
export const getOrigin = (data, page) => {
  let origin = data?.flights?.[0]?.departure?.airportCode;
  return origin;
};
export const getDestination = (data, page) => {
  let destination = data?.flights;
  let destinationCountryCode = destination?.[destination?.length - 1]?.arrival?.airportCode;
  return destinationCountryCode;
};
export const getErrorMsg = (data, errorCode) => {
  const errorMsg = data?.errorEntries;
  const msg = errorMsg?.filter(item => item?.errorCode === errorCode);
  const description = msg !== undefined && msg !== null ? msg[0]?.errorMessage : i18n.t("error_biometric_pass");
  return description;
};
export const getLocationName = () => {
  let path = window?.location?.pathname?.split("/")[3];
  switch (path) {
    case "select-passengers":
      return constant?.dapiDataLayer?.page_select_passenger_name;
    case "completed-checkin":
      return constant?.dapiDataLayer?.page_complete_checkin_name;
    case "passenger-details":
      return constant?.dapiDataLayer?.page_passenger_details;
    case "additional-services":
      return constant?.dapiDataLayer?.page_modify_seat_name;
    case "complete-checkin":
      return constant?.dapiDataLayer?.page_complete_checkin_name;
    case "cancel-checkin":
      return constant?.dapiDataLayer?.page_extra_services_cancel_checkin_name;
    case "passenger":
      return constant?.dapiDataLayer?.page_edit_passenger_name;
    case "seat-selection":
      return constant?.dapiDataLayer?.page_extra_services_seat_selection_name;
    case "dangerous-goods":
      return constant?.dapiDataLayer?.page_dangerous_goods_name;
    case "exit-row":
      return constant?.dapiDataLayer?.page_exit_row_questionnaire;
    case "samsungwallet":
      return constant?.dapiDataLayer?.page_samesung_wallet;
    case "canceled-checkin":
      return constant?.dapiDataLayer?.page_cancelled_checkin;
    case "checkin-failed":
      return constant?.dapiDataLayer?.page_cancel_fail;
    case "boarding-pass":
      return constant?.dapiDataLayer?.page_boarding_pass;
    default:
      return "";
  }
};
export const getSessionId = () => {
  return sessionStorage?.getItem("checkintoken");
};
export const getCheckedinPaxCount = data => {
  const count = data?.reduce((total, item) => {
    const countItem = item?.passengersArray?.filter(p => p?.checkin)?.length;
    return total + countItem;
  }, 0);
  return count;
};
export const getUniquePaxCount = data => {
  let dataLength = data?.reduce((acc, obj) => {
    if (!acc.some(item => item?.travelerId === obj?.travelerId)) {
      acc?.push(obj);
    }
    return acc;
  }, []);
  return dataLength?.length;
};
export const getUserId = () => {
  let id = sessionStorage?.getItem("memberId") ? sessionStorage?.getItem("memberId") : sessionStorage?.getItem("customerID") ? sessionStorage?.getItem("customerID") : "NA";
  return id;
};
export const getBaseLang = lng => {
  const parts = lng?.split("-");
  return parts?.reverse()?.join("/") || lng;
};
export const checkEligibleCountries = (insuranceCountries, siteEditions, origin) => {
  const checkMarket = i18n?.language?.split("-")?.[1];
  let checkEligibility = insuranceCountries?.includes?.(origin?.toLowerCase()) && checkMarket?.toLowerCase() === origin?.toLowerCase();
  return checkEligibility;
};
export const getOriginCode = flightList => {
  let originAirportCode = flightList?.[0]?.flights?.[0]?.departure?.airportCode;
  return originAirportCode;
};
export const getDestinationCode = flightList => {
  let destination = flightList?.[0]?.flights;
  let destinationAirportcode = destination?.[destination?.length - 1]?.arrival?.airportCode;
  return destinationAirportcode;
};
export const getPassengerCheckinCount = flightList => {
  let totalPax = flightList?.[0]?.passengers?.length;
  const checkedInTravelers = flightList?.[0]?.flightsArray?.flatMap(item => item?.checkedinPassengers?.map(checked => checked?.travelerId));
  const checkedInCount = [...new Set(checkedInTravelers)];
  return `Total ${totalPax} | ${checkedInCount?.length} checkin`;
};
export const getOriginDate = flightList => {
  let originDate = flightList?.[0]?.flights?.[0]?.departure?.date;
  return originDate;
};
export const getDestinationDate = flightList => {
  let destination = flightList?.[0]?.flights;
  let destinationDate = destination?.[destination?.length - 1]?.arrival?.date;
  return destinationDate;
};
export const getNamefromCode = (code, jsonData, type) => {
  if (!code || !jsonData || !type) return null;
  const upperCase = code?.trim()?.toUpperCase();
  const key = `global.${type}.${upperCase}`;
  return jsonData?.translation?.[key] || null;
};
export const mergeBoundsDicitionaries = orderData => {
  const bounds = orderData.data?.air?.bounds;
  const journeyFlights = orderData?.dictionaries;
  const mergeBounds = bounds?.map(item => ({
    ...item,
    flight: item.flights?.map?.(flight => ({
      ...flight,
      ...(journeyFlights?.flight[flight?.id] || {})
    }))
  }));
  return mergeBounds;
};
export const mergeCabinClass = (orderData, flightList) => {
  const merged = flightList?.map(item => ({
    ...item,
    flightsArray: item?.flightsArray?.map(data => {
      const marketingFlight = data?.marketingFlight?.code;
      const flightNumber = data?.marketingFlight?.flightNum;
      const matchedFlight = orderData?.flatMap(flightData => flightData?.flight).find(flightItem => flightItem?.marketingAirlineCode === marketingFlight && flightItem?.marketingFlightNumber === flightNumber);
      return matchedFlight ? {
        ...data,
        cabinName: matchedFlight?.cabin?.toLowerCase() === "ecopremiumplus" ? "premiumplus" : matchedFlight?.cabin
      } : data;
    })
  }));
  return merged;
};
export const isEcoPremiumPlus = data => {
  const isEcoPremiumAvailable = data?.some(item => item?.flights?.some(checked => checked?.cabin?.toLowerCase() === "ecopremiumplus"));
  return isEcoPremiumAvailable;
};
export const ecopremiumplusFlights = data => {
  const flightIds = data?.flatMap(item => item?.flight?.filter(flight => flight?.cabin?.toLowerCase() === "ecopremiumplus")).map(flightsCode => `${flightsCode?.marketingAirlineCode}${flightsCode?.marketingFlightNumber}`);
  return flightIds;
};
export const getHours = data => {
  let threshold = 0;
  if (data && data?.includes("D")) {
    const days = parseInt(data.replace("D", ""), 10);
    threshold = days * 24 * 60 * 60 * 1000;
  } else if (data && data?.includes("H")) {
    const hours = parseInt(data.replace("H", ""), 10);
    threshold = hours * 60 * 60 * 1000;
  }
  return threshold;
};
export const getPaxCounts = data => {
  const counts = {
    Total: 0,
    ADT: 0,
    CHD: 0,
    INF: 0
  };
  data?.forEach(journey => {
    journey?.flightsArray?.forEach(flight => {
      flight?.passengersArray?.forEach(pax => {
        if (pax?.passengerType === "ADT") counts.ADT++;
        if (pax?.passengerType === "CHD") counts.CHD++;
        if (pax?.infant) counts.INF++;
        counts.Total++;
      });
    });
  });
  return counts;
};
export const getGeneralMessages = (departureAirport, arrivalAirport, departureCountry, arrivalCountry, list) => {
  const messageSet = new Set();
  list.forEach(item => {
    const {
      validationtype,
      airportMultifield,
      countryCode,
      generalMessage1,
      passengerMessage
    } = item;
    const airportCodes = airportMultifield?.map(a => a.airportCode) ?? [];
    const airportMatch = airportCodes.includes(departureAirport) || airportCodes.includes(arrivalAirport);
    const arrivalAirportMatch = airportCodes.includes(arrivalAirport);
    const countryMatch = countryCode === departureCountry || countryCode === arrivalCountry;
    let isMatch = false;
    if (validationtype === "arrival") {
      isMatch = arrivalAirportMatch;
    }
    if (validationtype === "both" || !validationtype) {
      isMatch = airportMatch;
    }
    if (countryMatch) {
      isMatch = true;
    }
    if (isMatch) {
      if (generalMessage1) messageSet.add(generalMessage1);
    }
  });
  return Array.from(messageSet);
};
export const mergeFlightWithPax = data => {
  return data?.map(item => {
    const flightMap = item?.flights?.reduce((acc, f) => {
      acc[f?.flightId] = f;
      return acc;
    }, {});
    const passengers = item?.passengers?.map(pax => {
      const journeyElement = pax?.journeyElement?.map(jId => ({
        id: jId?.id,
        flightId: jId?.flightId
      }));
      const flightsForPax = pax?.journeyElement?.map(jourId => flightMap?.[jourId.flightId])?.filter(Boolean);
      return {
        ...pax,
        journeyElement,
        flights: flightsForPax
      };
    });
    return {
      ...item,
      passengers
    };
  });
};
export const checkTravelReady = (checkinConfig, response) => {
  const getMarketList = checkinConfig?.configList?.travelReady?.web?.markets;
  const isAllMarket = checkinConfig?.configList?.travelReady?.web?.allMarkets;
  const currentMarket = i18n?.language;
  const getRollOutStatus = getCheckinMarket(getMarketList, currentMarket);
  const flightLength = response?.passengerData?.flights?.length;
  const destinationFlag = checkinConfig?.configList?.travelReady?.web?.allDestinations || checkinConfig?.configList?.travelReady?.web?.destinations.includes(response?.passengerData?.flights?.[flightLength - 1]?.arrival?.airportCode);
  const isTREnabled = (getRollOutStatus || isAllMarket) && destinationFlag;
  sessionStorage?.setItem("isTREnabled", isTREnabled);
};